<ion-card class="order-card order-card--brand">
  <ion-card-header class="order-card-header" color="dark">
    <ion-card-title class="order-card-header__wrapper">
      <ion-label class="order-card-header__title">{{orderNumber}}{{orderDate}}</ion-label>
      <ion-text class="order-card-header__status">
        {{orderStatus.formattedStatus}}
        <span *ngIf="orderStatus.prep_time_duration">&#160;- ETA {{orderStatus.prep_time_duration}}</span>
      </ion-text>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content class="order-card__content">
    <div class="item-wrap" *ngFor="let item of orderStatus.line_items">
      <div class="item-container">
        <div class="item-name-wrap">
          <div class="item-name">
            {{item.name}} ({{item.variation_name}})
          </div>
          <div class="item-quantity">
            &nbsp;X {{item.quantity}}
          </div>
        </div>
        <div class="item-price">
          ${{getTotalPrice(item.total_price_money.amount)}}
        </div>
      </div>
      <div class="modifiers-wrap" *ngIf="item.modifiers.length">
        {{getModifiers(item.modifiers)}}
      </div>
    </div>
    <div class="item-details">
      <div class="details-wrap">
        <div class="details-name">
          Taxes and fees
        </div>
        <div class="details-price">
          ${{ getTotalPrice(orderStatus.tax_money.amount) }}
        </div>
      </div>

      <div class="details-wrap" *ngIf="orderStatus.delivery_fee_money.amount > 0">
        <div class="details-name">
          Delivery fees
        </div>
        <div class="details-price">
          ${{ getTotalPrice(orderStatus.delivery_fee_money.amount) }}
        </div>
      </div>

      <div class="details-wrap">
        <div class="details-name">
          Tip
        </div>
        <div class="details-price">
          ${{ getTotalPrice(orderStatus.tip_money.amount) }}
        </div>
      </div>

      <div class="details-wrap" *ngIf="orderStatus.driver_tip_money.amount > 0">
        <div class="details-name">
          Driver tip
        </div>
        <div class="details-price">
          ${{ getTotalPrice(orderStatus.driver_tip_money.amount) }}
        </div>
      </div>

      <div class="details-wrap" *ngIf="orderStatus.discount_money.amount > 0">
        <div class="details-name">
          Discounts
        </div>
        <div class="details-price">
          -${{ getTotalPrice(orderStatus.discount_money.amount) }}
        </div>
      </div>

      <div class="details-wrap">
        <div class="details-name">
          Total
        </div>
        <div class="details-price">
          ${{ getTotalPrice(orderStatus.total_money.amount) }}
        </div>
      </div>
    </div>

  </ion-card-content>
</ion-card>
